import { Component, Input } from '@angular/core';
import { CameraStream } from '../multi-camera-stream/multi-camera-stream.component';
import { CameraPlayerComponent } from '../camera-player/camera-player.component';

/**
 * Slot de cámara dentro de un mosaico. Wrapper fino sobre `app-camera-player`
 * que solo maneja el estado loading/error pre-render.
 */
@Component({
  selector: 'app-mosaic-video',
  standalone: true,
  imports: [CameraPlayerComponent],
  templateUrl: './mosaic-video.component.html',
  styleUrls: ['./mosaic-video.component.scss'],
})
export class MosaicVideoComponent {
  @Input() stream!: CameraStream;
  /** Sub-stream por default: en mosaico los tiles no necesitan 1080p. */
  @Input() mainStream = false;
}
